import { SHAMIR_RX_SURCHARGE_DEFAULTS, SHAMIR_SHARED_ROW_DEFAULTS } from '../../consts';
import { CatalogOutputRow, ShamirRXInputRow } from '../../types';
import { formatPrice, parseBooleanToBinary } from '../../utils';
import {
    getShamirRXFrameType,
    getShamirRXIndex,
    getShamirRXIsColored,
    getShamirRXIsPhotochromic,
    getShamirRXIsPolarising,
    getShamirRXLensType,
    getShamirRXMaterial,
    getShamirRXOpticalRange,
    getShamirRXPhotochromicColor,
    getShamirRXPolarisingColor,
    sumShamirRXDecimals,
} from './shamir-rx-field-parsers.util';

export const getShamirRXParsedRowData = (row: ShamirRXInputRow): CatalogOutputRow => {
    const name = `${row.description} ${row.coating}`;
    const material = getShamirRXMaterial(row.materialCode);
    const isPhotochromic = getShamirRXIsPhotochromic(name);
    const isPolarising = getShamirRXIsPolarising(name);
    const lensType = getShamirRXLensType(name);
    const isProgressive = lensType === 'Progresywne';
    const opticalRange = getShamirRXOpticalRange(name);
    const sphMin = opticalRange.sphMin;
    const sphMax = opticalRange.sphMax;
    const cylMax = opticalRange.cylMax;

    return {
        ...SHAMIR_SHARED_ROW_DEFAULTS,
        ...SHAMIR_RX_SURCHARGE_DEFAULTS,
        A: name,
        B: row.catalogNumber,
        F: formatPrice(row.buyPrice),
        G: formatPrice(row.sellPrice),
        I: parseBooleanToBinary(isPhotochromic),
        K: isPhotochromic ? getShamirRXPhotochromicColor(name) : 0,
        L: parseBooleanToBinary(isPolarising),
        M: isPolarising ? getShamirRXPolarisingColor(name) : 0,
        O: material,
        P: 'Sferyczne',
        Q: lensType,
        R: parseBooleanToBinary(getShamirRXIsColored(name)),
        W: row.coating,
        X: getShamirRXFrameType(name, material),
        Y: getShamirRXIndex(name),
        AB: isProgressive ? '0,75' : 0,
        AC: isProgressive ? 4 : 0,
        AD: 10,
        AE: 0,
        AF: sphMin,
        AG: sphMax,
        AH: cylMax,
        AI: sphMin,
        AJ: sphMax,
        AK: sphMin,
        AL: sumShamirRXDecimals(cylMax, sphMax),
    };
};
